module.exports = __webpack_public_path__ + "img/cz-partners-penize-cz.b7254776.png";